module.exports = __webpack_public_path__ + "static/media/low-flag.3bcb8142.svg";